import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How I accidentally lost my social skills",
  "description": "",
  "published": "2013-11-26T00:00:00.000Z",
  "redirect_from": ["/blog/how-i-accidentally-lost-my-social-skills/swizec/6434"],
  "categories": "Uncategorized",
  "hero": "./img/cbea837d8db67dd6c4762f8487cdaff9-tumblr_mwfqhuspxN1qekjngo1_500.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/statuses/271557734174961664"
      }}>{`https://twitter.com/Swizec/statuses/271557734174961664`}</a></p>
    <p>{`A year ago I was at the top of my social game. I could strike up a conversation with anyone anywhere. I could walk up to a girl, say hi, and spend the next twenty minutes in fascinating conversation.`}</p>
    <p>{`They all got confused when I wouldn't ask for their number. But I had my fun.`}</p>
    <p>{`52 straight weeks in bars. Sometimes more than once a week. I wasn't getting drunk, I went there to hang out and have fun talking to random people.`}</p>
    <p>{`For an introverted nerd who spent years afraid of talking to girls and fudging about for hours before picking up the phone to call someone this was huge.`}</p>
    <p>{`My quest to getting epic `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Social_skills",
        "title": "Social skills"
      }}>{`social skills`}</a>{` started a few years earlier when I had to learn "this networking thing". One of my favourite moments was inviting the internet for tea when I first came to `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.37,-122.04&spn=1.0,1.0&q=37.37,-122.04%20(Silicon%20Valley)&t=h",
        "title": "Silicon Valley"
      }}>{`Silicon Valley`}</a>{`. Many responded and I ended up having pleasant conversations over tea with about ten of them. Fun.`}</p>
    <p>{`For a while I even went partying once a week religiously. Much expense, many hangovers, and plenty nights being That Wird Guy Who Is Alone At A Club I learned how to get any girl talking to me.`}</p>
    <p>{`The trick is you shouldn't care. One of the more interesting conversations started with `}<em parentName="p">{`"Hey, you have nice boobs."`}</em>{` in response to which I learned that she was from Australia and it must be a European thing to say things like that.`}</p>
    <p>{`It's not a European thing.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "500px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/830e866c3456e95f45f21216f9f16fdd/41099/cbea837d8db67dd6c4762f8487cdaff9-tumblr_mwfqhuspxN1qekjngo1_500.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'400\\'%20viewBox=\\'0%200%20400%20400\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M338%20170l-1%202c0%202-4%204-4%203h-2c-1%201-1%201-3-1l-4-2c-2%201-3%204-1%204l-5%201-6-1h-2c-3%201-6%200-6-2s0-2-1-1v4c0%203%200%203-3%203l-4%201h-3l2-2c3-1%203-1%202-3-1-3-2-3-2-1s-1%203-3%203h-11l-1%201h-1c-1-2-5-1-5%201v3l-1-2c0-3-2-5-4-4h-4c-1-1-1-1-2%201l-1%201h-3l2%201%201%202c-1%201%200%202%202%202s3-1%202-2c0-2%201-3%203-1l3%203c2%202-1%205-3%203h-4l-2-1h-3l-7%201-6%201-3%201-2-1a1209%201209%200%2000-54-2c-1-1%200-1%202-1l3-1-18-1c-6%200-6-1-6-4l-2-1c-2-1-3%201-1%202v1l-3-1c0-2-1-2-7%200l-11%203c-8%201-5%201%2013%201a562%20562%200%200116%203l7%202c10%202%2015%203%208%203h-5l-4%201-4-1-4-1-5-1h-4c-2-1-2-1-2%201h-1l-1-1c0%202%200%202-2%201h-2c-1%202-11%201-11-1%201-1%200-1-1-1-2%200-2%200-1%201%202%201-1%202-5%201-5-2-16%200-15%202l-1%201-1-2-3-1c-3%201-13%200-19-2l-2%201c0%202-1%202-4%202l-4-1-4-1-4-1-4-1c-3%200-3%200-1%202%201%201%201%201-8%201-6%200-10-1-11-2h-1l-1-1-1-4v-8c-1-1-1-1%202-1s3%200-1-1c-6-1-8-1-7%203v10l-1%206-1-2-1-3v1c0%202-2%203-3%201h-3l-3%202h-8l-8-1c-2-2-3-2-3%200%200%201-4%202-12%201H0v208h401v-97l-1-112v-15h-3c-1%201-2%200-3-1-1-2-18%200-18%202l-2-1c-2-2-3-2-4-1-1%202-4%202-10%201l-3-1c1-1%200-1-2-1l-4%201h-2l-4-1c-2%200-2%200-2-2s0-2-2-3l-3%201M0%20296\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/830e866c3456e95f45f21216f9f16fdd/ca0a1/cbea837d8db67dd6c4762f8487cdaff9-tumblr_mwfqhuspxN1qekjngo1_500.webp 223w", "/static/830e866c3456e95f45f21216f9f16fdd/75680/cbea837d8db67dd6c4762f8487cdaff9-tumblr_mwfqhuspxN1qekjngo1_500.webp 445w", "/static/830e866c3456e95f45f21216f9f16fdd/b0a15/cbea837d8db67dd6c4762f8487cdaff9-tumblr_mwfqhuspxN1qekjngo1_500.webp 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/830e866c3456e95f45f21216f9f16fdd/853b2/cbea837d8db67dd6c4762f8487cdaff9-tumblr_mwfqhuspxN1qekjngo1_500.jpg 223w", "/static/830e866c3456e95f45f21216f9f16fdd/0a4fe/cbea837d8db67dd6c4762f8487cdaff9-tumblr_mwfqhuspxN1qekjngo1_500.jpg 445w", "/static/830e866c3456e95f45f21216f9f16fdd/41099/cbea837d8db67dd6c4762f8487cdaff9-tumblr_mwfqhuspxN1qekjngo1_500.jpg 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/830e866c3456e95f45f21216f9f16fdd/41099/cbea837d8db67dd6c4762f8487cdaff9-tumblr_mwfqhuspxN1qekjngo1_500.jpg",
                "alt": "San Francisco",
                "title": "San Francisco",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`San Francisco`}</figcaption>{`
  `}</figure></p>
    <p>{`But last autumn life got busy. I started writing books. My freelancing started picking up. Suddenly was spending my days cooped up in my room. Working. Writing. Sleeping.`}</p>
    <p>{`Despite having enough money to actually afford going out a lot, I never did. Eventually I stopped even going out for groceries. Family brought them anyway.`}</p>
    <p>{`The only thing that got me out of the house on a regular basis was boxing practice.`}</p>
    <p>{`I even started making friends at the gym, which is something I'd never done before. Sports are a place I go to be away from people. Making friends at the gym was a bad sign indeed. Something was up.`}</p>
    <p>{`Three weeks ago I came back to the Valley. My social circle is confined to the same house and roughly the same people I was with in June. Sure I have all my old friends on `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Internet_Relay_Chat",
        "title": "Internet Relay Chat"
      }}>{`IRC`}</a>{`, but it's not the same.`}</p>
    <p>{`When I go outside everyone is a stranger. I don't walk up to them to say hi. I don't do anything to break the stranger barrier. I barely even talk to service people, it feels weird.`}</p>
    <p>{`Going out is no better.`}</p>
    <p>{`There was a cute girl at the bar last week. A luscious redhead. After 20 minutes of gathering courage I walked up to her friend and said `}<em parentName="p">{`"Hi, have you seen how shiny my boots are?"`}</em></p>
    <p><em parentName="p">{`"No I haven't"`}</em>{`, she turned away.`}</p>
    <p>{`I tried to engage her again, to no avail. Somewhere along the line I had lost my ability to talk to girls. And that wasn't even a bad opener! A year ago I could've gotten a long conversation out of that one.`}</p>
    <p>{`It gets worse.`}</p>
    <p>{`On Saturday I met a bunch of new people in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.7833333333,-122.416666667&spn=0.1,0.1&q=37.7833333333,-122.416666667%20(San%20Francisco)&t=h",
        "title": "San Francisco"
      }}>{`SF`}</a>{` and because everyone was really into trying out their social game, I had five conversations in half an hour. My head spun and in the middle of talking to someone I ran to the bathroom and vomited.`}</p>
    <p>{`It might have been the dehydration coupled with drinking too much liquid all at once, but it wasn't a good reaction to have regardless.`}</p>
    <p>{`My social skills have gone off. Left in the fridge for too long they went bad like week old Indian food.`}</p>
    <p>{`But it doesn't have to be that way. Considering I have the discipline to work out a good hour a day, I should be able to spend at least `}<em parentName="p">{`some`}</em>{` time a week working on my social skills.`}</p>
    <p>{`With that in mind, it's time to start visiting coffee shops and bars again. I don't yet know how I'm going to make sure I have interesting conversations when writing from a coffee shop, but damn it I'm going to think of something.`}</p>
    <p>{`Even if it takes sticking a note saying `}<em parentName="p">{`"New to the area. Come say hi"`}</em>{` to the back of my laptop.`}</p>
    <p>{`Wish me luck.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=3f574e08-70a9-4df6-93fa-2501dfddb027",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      